import React, { useState, useEffect } from "react";
import { Link, useLocation, NavLink, useNavigate } from "react-router-dom";
import "./Header.css";
import { useAuth } from "../../context/AuthContext";
import { useCart } from "../../context/CartContext";
import logo from "../../assets/img/Learnific.png";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [lastSearch, setLastSearch] = useState("");
  const { user, handleLogout } = useAuth();
  const { cartCount } = useCart();

  const toggleSearch = (e) => {
    e.preventDefault();
    setSearchOpen(!searchOpen);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    const trimmed = searchTerm.trim();
    const timer = setTimeout(() => {
      if (trimmed.length >= 3 && trimmed !== lastSearch) {
        navigate(`/search?q=${encodeURIComponent(trimmed)}`);
        setLastSearch(trimmed);
      }
      if (trimmed.length === 0 && lastSearch !== "") {
        navigate("/search?q=");
        setLastSearch("");
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [searchTerm, lastSearch, navigate]);

  useEffect(() => {
    if (!location.pathname.startsWith("/search")) {
      setSearchTerm("");
      setLastSearch("");
    }
  }, [location.pathname]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="header sticky">
      <div className="container header-inner">
        {/* Logo */}
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            <img src={logo} alt="logo" />
          </Link>
        </div>

        {/* Navigation - Desktop */}
        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <ul className="nav navbar-nav">
            <li className={location.pathname === "/" ? "active" : ""}>
              <Link to="/" onClick={closeMenu}>
                <i className="fa fa-home"></i> Home
              </Link>
            </li>
            <li className={location.pathname === "/about" ? "active" : ""}>
              <Link to="/about" onClick={closeMenu}>
                <i className="fa fa-user"></i> About
              </Link>
            </li>
            <li className={location.pathname === "/courses" ? "active" : ""}>
              <Link to="/courses" onClick={closeMenu}>
                <i className="fa fa-book"></i> Courses
              </Link>
            </li>
            <li className={location.pathname === "/contact" ? "active" : ""}>
              <Link to="/contact" onClick={closeMenu}>
                <i className="fa fa-envelope"></i> Contact
              </Link>
            </li>
          </ul>
        </nav>

        {/* Right Actions */}
        <div className="header-actions">
          {/* Cart */}
          <Link to="/cart" className="cart-icon" onClick={closeMenu}>
            <i className="fa fa-shopping-bag"></i>
            {cartCount > 0 && (
              <span className="cart-badge">{cartCount}</span>
            )}
          </Link>

          {/* Search */}
          <div className={`search-area ${searchOpen ? "active" : ""}`}>
            <a href="#search" className="icon" onClick={toggleSearch}>
              <i className={`fa ${searchOpen ? "fa-times" : "fa-search"}`}></i>
            </a>
            <form className="search-form" onSubmit={(e) => e.preventDefault()}>
              <input
                type="text"
                placeholder="Search courses"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button type="submit">
                <i className="fa fa-search"></i>
              </button>
            </form>
          </div>

          {/* Auth */}
          {user ? (
            <div className="user-menu">
              <div className="user-icon-wrap">
                <i className="fa fa-user user-icon"></i>
                <span className="username">Hello, {user.firstName}</span>
                <i className="fa fa-caret-down caret-icon"></i>
              </div>
              <div className="dropdown-menu">
                <NavLink to="/profile" className="dropdown-item">
                  <i className="fa fa-user-circle"></i> Profile
                </NavLink>
                {/* <NavLink to="/orders" className="dropdown-item">
                  <i className="fa fa-box"></i> Orders
                </NavLink> */}
                <button onClick={handleLogout} className="dropdown-item logout-btn">
                  <i className="fa fa-sign-out"></i> Logout
                </button>
              </div>
            </div>
          ) : (
            <div className="auth-links">
              <Link to="/login" className="btn btn-outline-primary">
                Login
              </Link>
              <Link to="/register" className="btn btn-primary">
                Register
              </Link>
            </div>
          )}
        </div>

        {/* Hamburger - Mobile Only */}
        <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <i className={`fa ${menuOpen ? "fa-times" : "fa-bars"}`}></i>
        </button>
      </div>
    </header>
  );
};

export default Header;
